import {createContext, useContext} from 'react';

/**
 * Imperative API for the grid's Tab focus navigation. Components use the register
 * callbacks to publish their DOM nodes into a ref registry held by the provider;
 * the grid root wires handleKeyDown/handleBlur. State (which row/action is focused)
 * lives in the EagGrid store — this context only carries the imperative bits.
 */
export type GridKeyboardNavContextValue = {
  registerSearchContainer: (el: HTMLElement | null) => void;
  registerRow: (rowIndex: number, el: HTMLTableRowElement | null) => void;
  registerActionCell: (rowIndex: number, el: HTMLElement | null) => void;
  handleKeyDown: (event: React.KeyboardEvent) => void;
  handleBlur: (event: React.FocusEvent) => void;
};

export const GridKeyboardNavContext = createContext<GridKeyboardNavContextValue | null>(null);

/**
 * Returns the grid keyboard-nav API. Returns null when used outside the provider
 * (optional) so leaf components (rows, action cells, search) can no-op gracefully
 * in isolation (e.g. unit tests that render a single component without the provider).
 */
export function useGridKeyboardNav(): GridKeyboardNavContextValue | null {
  return useContext(GridKeyboardNavContext);
}
